import { initializeWebMCPPolyfill } from '@mcp-b/webmcp-polyfill';
import { isWebMCPSupported } from './webmcpSupported';

export { isWebMCPSupported } from './webmcpSupported';

/**
 * Install the WebMCP polyfill when native support is absent.
 * Safe to call once at app startup; no-ops when modelContext already exists.
 */
export const initializeWebMCPIfNeeded = (): void => {
  if (typeof document === 'undefined') {
    return;
  }

  if (!isWebMCPSupported()) {
    initializeWebMCPPolyfill();
  }
};
